import { render } from "./Home.vue?vue&type=template&id=28f92752&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=28f92752&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28f92752"

export default script